import { HttpHandler } from 'msw';
import { setupWorker } from 'msw/browser';

import * as apis from './api';

type ApiName = keyof typeof apis;
export type MswHandlerType = Record<ApiName, HttpHandler>;
export const handlers: MswHandlerType = apis;

export const worker = setupWorker(...Object.values(handlers));
